<template>
  <div class="p-4">
    <HeaderDetailItemSR
      :selectedItem="selectedItem"
      :optionsTaskType="optionsTaskType"
      :optionsDepartment="optionsDepartment"
      :optionsCategory="optionsCategory"
      :optionsClassification="optionsClassification"
      :optionsCause="optionsCause"
      :optionsKindTask="optionsKindTask"
      :editable="false"
    />
    <b-row>
      <b-col md="12" class="mt-4 mb-3">
        <CustomNav :items="tabs" @item-click="(val) => (activeTab = val)" />
      </b-col>
      <b-col
        md="12"
        class="d-flex justify-content-end"
        v-if="activeTab == 1 && !readonly"
      >
        <b-button
          size="sm"
          variant="outline-primary"
          @click="showSidebar = true"
          >Add Progress Activity</b-button
        >
      </b-col>
      <b-col md="12" class="mt-3">
        <template v-if="activeTab == 1">
          <ListDailyProgress :data="listActivity" />
        </template>
        <template v-if="activeTab == 2">
          <ListInternalManPower :data="selectedItem.internal_manpower" />
        </template>
        <template v-if="activeTab == 3">
          <ListSubContractor :data="selectedItem.subcons" />
        </template>
      </b-col>
    </b-row>
    <b-sidebar
      v-model="showSidebar"
      right
      width="50%"
      title="Add Progress Item Repair"
      @hidden="onHide"
      shadow
      bg-variant="white"
    >
      <form class="p-3" @submit.prevent="onSaveBulk">
        <div
          class="card-sr-information-form p-3 border mb-3"
          v-for="(form, index) in formActivity"
          :key="index"
        >
          <b-row>
            <b-col class="mb-3" md="12">
              <label for="activity"
                >Activity <span class="text-red">*</span></label
              >
              <b-form-select
                v-model="form.activity_id"
                required
                size="sm"
                :options="optionsActivity"
              >
              </b-form-select>
            </b-col>
            <b-col class="mb-3" md="6">
              <label for="activity"
                >Start Activity <span class="text-red">*</span></label
              >
              <date-picker
                v-model="form.date_of_activity"
                class="w-100"
                value-type="YYYY-MM-DD HH:mm:ss"
                type="datetime"
                placeholder="Select date and time"
                format="DD-MM-YYYY HH:mm:ss"
              ></date-picker>
            </b-col>
            <b-col class="mb-3" md="6">
              <label for="activity"
                >End Activity <span class="text-red">*</span></label
              >
              <date-picker
                v-model="form.end_of_activity"
                class="w-100"
                value-type="YYYY-MM-DD HH:mm:ss"
                type="datetime"
                placeholder="Select date and time"
                format="DD-MM-YYYY HH:mm:ss"
                :disabled-date="(date) => disableEndDate(date, form)"
                :disabled="!form.date_of_activity"
              ></date-picker>
            </b-col>
            <b-col md="6">
              <label for="activity">Activity Attachment</label>
              <InputFileMultiple
                @change-files="(val) => handleInputFiles(val, form)"
                :files="form.filePreview"
              ></InputFileMultiple>
            </b-col>
            <b-col md="12" class="mb-3 mt-2">
              <b-row class="m-0">
                <b-col
                  lg="3"
                  class="p-0 pr-2"
                  v-for="(url, idx) in form.filePreview"
                  :key="`${index}-${idx}`"
                >
                  <AttachmentSR
                    :modelId="form.id"
                    modelName="sr_form_repair_activity"
                    :file="url"
                    @delete="() => handleDeleteFile(form, idx)"
                  />
                </b-col>
              </b-row>
            </b-col>
            <b-col class="mb-3" md="12">
              <label for="activity">Remarks</label>
              <b-form-textarea
                class="bg-white"
                v-model="form.notes"
              ></b-form-textarea>
            </b-col>
          </b-row>
        </div>
        <div class="mt-3 d-flex justify-content-end">
          <b-button
            type="button"
            variant="outline-primary"
            class="mr-2"
            @click="showSidebar = false"
            >Cancel & Close</b-button
          >
          <b-button
            type="button"
            variant="outline-primary"
            class="mr-2"
            @click="addForm"
            >Add Form</b-button
          >
          <b-button v-if="!loading" type="submit" variant="primary"
            >Save & Close</b-button
          >
          <b-button v-else type="button" variant="primary">
            <b-spinner small class="mr-2"></b-spinner> Loading...
          </b-button>
        </div>
      </form>
    </b-sidebar>
  </div>
</template>
<script>
import CustomNav from '@/src/components/global/CustomNav.vue'
import ListInternalManPower from './ListInternalManPower.vue'
import ListSubContractor from './ListSubContractor.vue'
import HeaderDetailItemSR from './HeaderDetailItemSR.vue'
import ListDailyProgress from './ListDailyProgress.vue'
import AttachmentSR from './AttachmentSR.vue'
import { srActions } from '@/src/Utils/helper'
import moment from '@/node_modules/moment/moment'
import InputFileMultiple from '@/src/components/global/InputFileMultiple.vue'

export default {
  name: 'DetailItemSR',
  props: {
    formId: null,
    readonly: Boolean,
    defaultParams: {
      type: Object,
      default: () => {},
    },
    selectedItem: {
      type: Object,
      default: () => {},
    },
    optionsTaskType: {
      type: Array,
      default: () => [],
    },
    optionsDepartment: {
      type: Array,
      default: () => [],
    },
    optionsCategory: {
      type: Array,
      default: () => [],
    },
    optionsClassification: {
      type: Array,
      default: () => [],
    },
    optionsCause: {
      type: Array,
      default: () => [],
    },
    optionsKindTask: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    CustomNav,
    ListInternalManPower,
    ListSubContractor,
    HeaderDetailItemSR,
    ListDailyProgress,
    AttachmentSR,
    InputFileMultiple,
  },
  data() {
    return {
      activeTab: 1,
      showSidebar: false,
      loading: false,
      optionsActivity: [],
      listActivity: [],
      formActivity: [
        {
          id: this.formId,
          form_repair_id: this.selectedItem.id,
          activity_id: null,
          date_of_activity: null,
          notes: '',
          is_finished: false,
          end_date_activity: null,
          file: [],
          filePreview: [],
        },
      ],
      tabs: [
        { label: 'Daily Progress', value: 1 },
        { label: 'Internal Man Power', value: 2 },
        { label: 'Sub Contractor', value: 3 },
      ],
    }
  },
  methods: {
    ...srActions,
    disableEndDate(date, form) {
      if (!form.date_of_activity) return true // disable semua kalau belum pilih start
      return date < new Date(form.date_of_activity)
    },
    onHide() {
      this.formActivity = [
        {
          id: this.formId,
          form_repair_id: this.selectedItem.id,
          activity_id: null,
          date_of_activity: null,
          notes: '',
          is_finished: false,
          end_date_activity: null,
          file: [],
          filePreview: [],
        },
      ]
    },
    addForm() {
      this.formActivity.push({
        id: this.formId,
        form_repair_id: this.selectedItem.id,
        activity_id: null,
        date_of_activity: null,
        notes: '',
        is_finished: false,
        end_date_activity: null,
        file: [],
        filePreview: [],
      })
    },
    handleDeleteFile(item, idx) {
      const newFiles = item.filePreview.filter((_, i) => i !== idx)
      const newFileUploads = item.file.filter((_, i) => i !== idx)
      item.filePreview = newFiles
      item.file = newFileUploads
    },
    handleInputFiles(val, item) {
      if (!val) return false
      const files = val
      if (files.length) {
        Array.from(files).forEach((file) => {
          item.file.push(file)
          item.filePreview.push({
            url: URL.createObjectURL(file),
            name: file.name,
            type: file.type,
          })
        })
      }
    },
    async getMasterActivity() {
      let res = await this.fetchMasterActivity(this.defaultParams)
      if (res.status === 'error') {
        this.optionsActivity = []
      } else {
        res.data.map((val) => {
          this.optionsActivity.push({
            text: val.name,
            value: val.id,
          })
        })
      }
    },

    async onSaveActivity(payload) {
      let formData = new FormData()
      formData.append('user_id', JSON.parse(localStorage.getItem('profile')).id)
      formData.append(
        'user_name',
        JSON.parse(localStorage.getItem('profile')).userDetail.name
      )
      formData.append('form_repair_id', payload.form_repair_id)
      formData.append('activity_id', payload.activity_id)
      formData.append(
        'date_of_activity',
        moment(payload.date_of_activity).format('YYYY-MM-DD HH:mm:ss')
      )
      formData.append(
        'end_of_activity',
        moment(payload.end_of_activity).format('YYYY-MM-DD HH:mm:ss')
      )
      formData.append('is_finished', payload?.activity_id == 13 ? true : false)
      formData.append('notes', payload.notes)
      payload.file.forEach((file, fileIndex) => {
        formData.append(`file[${fileIndex}]`, file)
      })

      // formData.forEach((value, key) => {
      //   console.log(key, value)
      // })

      const res = await this.setActivityRepair({
        id: payload.id,
        formData,
        params: this.defaultParams,
      })

      if (res.status === 'success') {
        return res
      } else {
        throw res
      }
    },
    async onSaveBulk() {
      this.loading = true
      try {
        const requests = this.formActivity.map((payload, index) =>
          this.onSaveActivity(payload)
        )
        const responses = await Promise.all(requests)
        this.$swal(`Berhasil!`, `Menambahkan aktivitas berhasil.`, 'success')
      } catch (error) {
        this.$swal(`Oops!`, `Failed Create Daily Progresss!`, 'error')
      } finally {
        this.$emit('refetch')
        this.showSidebar = false
        this.loading = false
        this.getSingleRepairData()
      }
    },
    async getSingleRepairData(limit = 100) {
      try {
        let params = { limit, ...this.defaultParams }
        if (this.selectedItem.id) {
          this.minDate = ''
          let res = await this.fetchSingleRepair({
            id: this.selectedItem.id,
            params,
          })
          if (res.status === 'error') {
          } else {
            this.listActivity = res.data.activity.map((el) => ({
              ...el,
              file: JSON.parse(el.file),
            }))
          }
        }
      } catch (error) {
        conosle.log('error-fetch-daily-progress', error)
      }
    },
    resetForm() {
      this.formActivity = [
        {
          id: this.formId,
          form_repair_id: this.selectedItem.id,
          activity_id: null,
          date_of_activity: null,
          date_of_activity: null,
          notes: '',
          is_finished: false,
          end_date_activity: null,
          file: [],
          filePreview: [],
        },
      ]
    },
  },
  mounted() {
    this.getMasterActivity()
    this.getSingleRepairData()
  },
}
</script>
<style scoped>
.card-sr-information-form {
  background: #f7f7f7;
  border-radius: 10px;
}

.text-red {
  color: red;
}
</style>
